import { maxLength, minLength, required } from 'vuelidate/lib/validators'
import { ValidatorsHelper } from '@/helpers/Validators'

export const dateOfBirth = {
  required,
  date: ValidatorsHelper.isBirthDate
}

export const email = {
  required,
  email: ValidatorsHelper.isMail
}

export const firstName = {
  required,
  minLength: minLength(2),
  maxLength: maxLength(35),
  name: ValidatorsHelper.isName
}

export const lastName = {
  required,
  minLength: minLength(2),
  maxLength: maxLength(60),
  name: ValidatorsHelper.isName
}

export const mobile = {
  required,
  mobile: function (value) {
    return ValidatorsHelper.isMobileNumber(value)
  }
}

export const phone = {
  required,
  phone: function (value) {
    return ValidatorsHelper.isValidPhoneNumber(value)
  }
}
